import React from 'react';
import { useSearchParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { ACCESS_ROLES_SUBTABS } from './adminSections';
import AdminAccess from './AdminAccess';
import AdminInvites from './AdminInvites';
import AdminPermissions from './AdminPermissions';
import AdminWebRoles from './AdminWebRoles';
import AdminUsers from './AdminUsers';

const SUBTAB_COMPONENTS = {
  access: AdminAccess,
  invites: AdminInvites,
  permissions: AdminPermissions,
  'web-roles': AdminWebRoles,
  users: AdminUsers,
};

/**
 * Åtkomst & Roller — merged container for the access/RBAC admin screens that
 * each used to be their own sidebar tab (Spelaråtkomst, Invites, Behörigheter,
 * Web-roller, Användare). Renders them as sub-tabs, gated by the same
 * permission checks they had standalone. The active sub-tab is driven by the
 * `?sub=` query param so legacy `/webadmin/<path>` URLs redirect here cleanly.
 */
export default function AdminAccessRoles({ perms }) {
  const { t } = useTranslation();
  const [searchParams, setSearchParams] = useSearchParams();

  const visibleTabs = ACCESS_ROLES_SUBTABS.filter((tab) => tab.check(perms));

  const requested = searchParams.get('sub');
  const activeKey = visibleTabs.some((tab) => tab.key === requested)
    ? requested
    : (visibleTabs[0]?.key || null);

  const setActive = (key) => setSearchParams({ sub: key }, { replace: true });

  const ActiveComponent = activeKey ? SUBTAB_COMPONENTS[activeKey] : null;

  return (
    <div>
      <h1 className="admin-section-title">{t('admin.navAccessRoles')}</h1>

      <div className="admin-tabs">
        {visibleTabs.map((tab) => (
          <button
            key={tab.key}
            className={`admin-tab ${activeKey === tab.key ? 'active' : ''}`}
            onClick={() => setActive(tab.key)}
          >
            {t(tab.labelKey)}
          </button>
        ))}
      </div>

      {ActiveComponent ? (
        <ActiveComponent perms={perms} hideTitle />
      ) : (
        <div className="admin-info">{t('admin.noAccessSection')}</div>
      )}
    </div>
  );
}
